//Реакт
import React from "react";
//Компоненты
import TableCol from "../../../modules/table/__col";
//Стили
import "./styles.css";

export default function ListBodyItem({children, onClick, className = '', ...other}){
    return <TableCol onClick={onClick} className={className} {...other}>{children}</TableCol>
}